// @mui
import { Box } from "@mui/material"
// components
import { IconButtonAnimate } from "minimals-template/components/animate"
import Iconify from "minimals-template/components/Iconify"
import React from "react"

// ----------------------------------------------------------------------

const CollapseButton = React.forwardRef(function CollapseButton(
    { onToggleCollapse, collapseClick, sx, ...props },
    ref
) {
    return (
        <IconButtonAnimate
            ref={ref}
            onClick={onToggleCollapse}
            {...props}
            aria-label={collapseClick ? "Expand Navigation" : "Collapse Navigation"}
            sx={{
                p: 0,
                width: 36,
                height: 36,
                color: "text.secondary",
                bgcolor: "background.paper",
                border: (theme) => `1px solid ${theme.palette.divider}`,
                "&:hover": { bgcolor: "background.neutral" },
                ...sx,
            }}
        >
            <Box
                sx={{
                    lineHeight: 0,
                    display: "inline-flex",
                    transition: (theme) =>
                        theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                        }),
                    ...(collapseClick && {
                        transform: "rotate(180deg)",
                    }),
                }}
            >
                <Iconify icon="mingcute:left-line" width={22} height={22} />
            </Box>
        </IconButtonAnimate>
    )
})

export default CollapseButton
